import Swal from "sweetalert2";
import { escapeHtml } from "./xss";

const defaultClasses = {
  popup: "modern-swal-popup",
  title: "modern-swal-title",
  content: "modern-swal-body",
  confirmButton: "modern-swal-confirm",
  closeButton: "modern-swal-close",
};

export function showSwal({
  title = "",
  message = "",
  icon = "info",
  confirmText = "OK",
  showCloseButton = false,
  backdrop = "rgba(3,10,26,0.6)",
  customClass = {},
  /** When true, `message` is treated as trusted HTML (caller must sanitize). Default: escape. */
  allowHtml = false,
  ...rest
} = {}) {
  const safeMessage = allowHtml ? String(message ?? "") : escapeHtml(message);
  return Swal.fire({
    title,
    html: `<div class="modern-swal-content">${safeMessage}</div>`,
    icon,
    confirmButtonText: confirmText,
    showCloseButton,
    backdrop,
    showClass: { popup: "swal2-zoom-in" },
    hideClass: { popup: "swal2-zoom-out" },
    buttonsStyling: false,
    customClass: { ...defaultClasses, ...customClass },
    ...rest,
  });
}

export function showMissingInvoice(message = "Please enter invoice number") {
  return showSwal({
    title: "Missing Invoice No.",
    message,
    icon: "warning",
    showCloseButton: true,
    confirmText: "OK",
  });
}

export function showError(message = "An error occurred") {
  return showSwal({
    title: "Error",
    message,
    icon: "error",
    showCloseButton: true,
    confirmText: "OK",
    allowOutsideClick: false,
  });
}

export function showInvoiceNotFound() {
  return Swal.fire({
    title: "Invoice Not Found",
    text: "The entered Invoice Number was not found in SAP. Please verify the Invoice Number and try again.",
    icon: "error",
    showCancelButton: true,
    confirmButtonColor: "#ff9800",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Retry Search",
    cancelButtonText: "Return to Dashboard",
    allowOutsideClick: false, // Blocking popup - user must choose
    allowEscapeKey: false,    // Prevent ESC key from closing
  });
}

export default { showSwal, showMissingInvoice, showError, showInvoiceNotFound };
